import styled, {css} from 'styled-components'
import {Item, Root} from '@radix-ui/react-toggle-group'

export const StyledToggleGroupTeamRoot = styled(Root)(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        width: fit-content;
        background-color: ${palette.neutral['white']};
        border: 1px solid ${palette.neutral['200']};
        border-radius: 8px;
        overflow: hidden;
    `
)

export const StyledToggleGroupTeamItem = styled(Item)(
    ({theme: {palette, spacing}}) => css`
        padding: ${spacing}px;
        min-width: 60px;
        text-align: center;
        cursor: pointer;
        color: ${palette.neutral['600']};
        font-weight: 500;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;

        &[data-state='on'] {
            background-color: ${palette.primary['50']};
            color: ${palette.primary['600']};
            border: 1px solid ${palette.primary['200']};
        }
    `
)
